import React from 'react'

interface TabsProps {
  value: string
  onValueChange: (value: string) => void
  children: React.ReactNode
  className?: string
}

export const Tabs: React.FC<TabsProps> = ({ children, className = '' }) => {
  return <div className={`tabs-container ${className}`}>{children}</div>
}

interface TabsListProps {
  children: React.ReactNode
  className?: string
}

export const TabsList: React.FC<TabsListProps> = ({ children, className = '' }) => {
  return (
    <div className={`flex space-x-1 rounded-lg bg-gray-100 p-1 ${className}`}>
      {children}
    </div>
  )
}

interface TabsTriggerProps {
  value: string
  children: React.ReactNode
  className?: string
}

export const TabsTrigger: React.FC<TabsTriggerProps> = ({ children, className = '' }) => {
  return (
    <button
      className={`flex items-center justify-center rounded-md px-3 py-1.5 text-sm font-medium transition-all hover:bg-white hover:text-gray-900 ${className}`}
    >
      {children}
    </button>
  )
}

interface TabsContentProps {
  value: string
  children: React.ReactNode
  className?: string
}

export const TabsContent: React.FC<TabsContentProps> = ({ children, className = '' }) => {
  return <div className={`mt-4 ${className}`}>{children}</div>
}